import React, { useState, useEffect, useContext } from "react"
import { ButtonGroup, Col, Form, Row, Tab, Tabs } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import {
  isAdmin,
  refreshPage,
  toastStyle,
  TokenExpiry,
  numberFormat,
  numberFormatInt,
  selectDropdownStyle,
} from "../../../Helpers/Utils/Common"
import Moment from "moment"
import Navbar from "../../../Components/Navbar/Navbar"
import toast from "react-hot-toast"
import DeleteModal from "../../../Components/Modals/DeleteModal"
import {
  approveSuppliesExpense,
  changeStatus,
  changeMultipleStatusSE,
} from "../../../Helpers/apiCalls/Purchases/suppliesExpensesApi"
import { getType } from "../../../Helpers/Utils/Common"
import "../PurchaseOrders/PurchaseOrders.css"
import SEModal from "./Components/SEModal"
import { searchSE } from "../../../Helpers/apiCalls/Purchases/suppliesExpensesApi"
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import POModal from "../PurchaseOrders/Components/POModal"
import PoPaymentModal from "./Components/PoPaymentModal"
import Select from "react-select"
import DatePicker from "react-datepicker"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"
import AdjustmentTableWithDynamicPagination from "../../../Components/TableTemplate/AdjustmentTableWithDynamicPagination"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function SuppliesExpenses() {
  let navigate = useNavigate()
  const { setDateFrom, setDateTo, dateFilter, currentTab, setCurrentTab } =
    useContext(Context)
  const [showLoader, setShowLoader] = useState(false)
  const [supExpenseID, setSupExpenseID] = useState("")
  const [userType] = useState(getType())
  const [isClicked, setIsClicked] = useState(false)
  /* delete modal handler */
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleShowDeleteModal = () => setShowDeleteModal(true)
  const handleCloseDeleteModal = () => setShowDeleteModal(false)
  const [checkedItems, setCheckedItems] = useState([])
  const [filterConfig, setFilterConfig] = useState({
    tab: currentTab
      ? currentTab
      : userType === "admin"
      ? "for_approval"
      : "pending",
    branch_id: "",
    status: userType === "admin" ? "for_approval" : "pending",
    order_status: "",
    page: 1,
    to: dateFilter.date_to || "",
    from: dateFilter.date_from || "",
  })
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10 // Change this based on your requirement

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  async function handleDeleteSuppliesExpense() {
    setIsClicked(true)
    const response = await approveSuppliesExpense(supExpenseID.id, "deleted")
    // const response = await deleteSuppliesExpense(supExpenseID.id);
    // ;
    if (response.data) {
      toast.success("Supplies Expense Deleted Successfully!", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      toast.error("Error Deleting Supplies Expense", {
        style: toastStyle(),
      })
    }
    setIsClicked(false)
  }
  /* return modal handler */
  const [showReturnModal, setShowReturnModal] = useState(false)
  const handleShowReturnModal = () => setShowReturnModal(true)
  const handleCloseReturnModal = () => setShowReturnModal(false)

  /* close modal handler */
  const [showClosePOModal, setShowClosePOModal] = useState(false)
  const handleShowClosePOModal = () => setShowClosePOModal(true)
  const handleCloseClosePOModal = () => setShowClosePOModal(false)

  const [inactive, setInactive] = useState(true)
  const [suppliesExpenseManager, setSuppliesExpenseManager] = useState([])
  const [bal, setBal] = useState("")
  /* add payment modal handler */
  const [showAddPaymentModal, setShowAddPaymentModal] = useState(false)
  const handleShowAddPaymentModal = () => setShowAddPaymentModal(true)
  const handleCloseAddPaymentModal = () => setShowAddPaymentModal(false)

  /* approve modal handler */
  const [showApproveModal, setShowApproveModal] = useState(false)
  const handleShowApproveModal = () => {
    checkedItems.length != 0
      ? setShowApproveModal(true)
      : toast.error("Please select order/s to approve", {
          style: toastStyle(),
        })
  }
  const handleCloseApproveModal = () => setShowApproveModal(false)

  /* disapprove modal handler */
  const [showDisapproveModal, setShowDisapproveModal] = useState(false)
  const handleShowDisapproveModal = () => {
    checkedItems.length != 0
      ? setShowDisapproveModal(true)
      : toast.error("Please select order/s to disapprove", {
          style: toastStyle(),
        })
  }
  const handleCloseDisapproveModal = () => setShowDisapproveModal(false)

  const [suppliers, setSuppliers] = useState([])

  const [supplierList, setSupplierList] = useState([])
  const [selectedSupplier, setSelectedSupplier] = useState("")

  function handleSupplierChange(e) {
    setSelectedSupplier({
      label: e.label,
      value: e.value,
    })
    setFilterConfig((prev) => {
      return { ...prev, supplier_id: e.value }
    })
    // setSelectedSupplier(e.name);
    // const toFilter = { target: { name: "supplier_id", value: e.value } };
    // handleFilterChange(toFilter);
  }

  async function fetchSuppliers() {
    setSuppliers([])

    const suppliersResponse = await getAllSuppliers()

    if (suppliersResponse.error) {
      TokenExpiry(suppliersResponse)
    } else {
      var suppliers = suppliersResponse.data.data.map((supplier) => {
        var info = supplier
        info.label = supplier.trade_name
        info.value = supplier.id
        return info
      })
      setSuppliers([{ label: "All Suppliers", value: "" }, ...suppliers])
    }
  }

  async function handleReceiveSE(id) {
    navigate("/se/purchaseinvoices/add/" + id)
  }

  async function handleReturnSE() {
    const response = await approveSuppliesExpense(supExpenseID.id, "pending")
    if (response.data.response) {
      toast.success("Supplies Expense Returned to Pending", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      toast.error("Error Returning Supplies Expense to Pending", {
        style: toastStyle(),
      })
    }
  }
  const [selectedSEId, setSelectedSEId] = useState("")
  async function handleSelectChange(e, suppID, type, row) {
    const { id, value } = e.target
    setSupExpenseID({
      id: id,
      supplier: suppID,
      name: row.supplier_trade_name
        ? row.supplier_trade_name
        : row.vendor_trade_name,
    })

    var _baseURL = "suppliesexpenses/"

    if (value === "edit-supExpense") {
      window.open(_baseURL + "edit/" + type + "/" + id, "_blank")
    } else if (value === "delete-supExpense") {
      handleShowDeleteModal()
    } else if (value === "return-supExpense") {
      handleShowReturnModal()
    } else if (value === "print-supExpense") {
      navigate("print/" + id, {
        state: { type: type, suppID: suppID },
      })
    } else if (value === "review-supExpense") {
      navigate("review/" + id, "_blank")
    } else if (value === "email-supExpense") {
      navigate("print/" + id, {
        state: { type: type, suppID: suppID },
      })
    } else if (value === "view-supExpense") {
      window.open(_baseURL + "review/" + id, "_blank")
    } else if (value === "receive-supExpense") {
      handleReceiveSE(id)
    } else if (value === "close-supExpense") {
      setSelectedSEId(id)
      handleShowClosePOModal()
    } else if (value === "payment-po") {
      setBal(numberFormatInt(row.balance))
      handleShowAddPaymentModal()
    } else if (value === "close-po") {
      setSelectedSEId(id)
      handleShowClosePOModal()
    } else if (value === "view-po") {
      window.open(_baseURL + "review/" + id, "_blank")
    }
  }

  async function handleClosePO() {
    var data = {
      se_id: selectedSEId,
      new_status: "complete",
    }
    setIsClicked(true)
    const response = await changeStatus(data)
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      })
      handleCloseClosePOModal()
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: "complete",
          order_status: "complete",
        }
      })
    } else {
      TokenExpiry(response)
      toast.error("Error closing supplies purchase order", {
        style: toastStyle(),
      })
    }
  }

  async function searchSuppliesExpense(filterConfig) {
    setSuppliesExpenseManager([])
    setTotalItems(0)
    setShowLoader(true)
    const response = await searchSE(filterConfig)
    if (response.data) {
      var SE = response.data.data.map((se) => {
        var info = se
        info.supplies_expense_date = Moment(se.supplies_expense_date).format(
          "MMM DD, YYYY"
        )
        info.supplier_trade_name = se.supplier_id
          ? se.supplier_trade_name
          : se.vendor_id
          ? se.vendor_trade_name
          : "N/A"
        info.grand_total = numberFormat(info.grand_total)
        info.balance = numberFormat(info.balance)
        info.invoice = se.invoice_no?.map((invoice) => {
          return invoice.invoice_no ? invoice.invoice_no : ""
        })
        info.invoice_id = se.invoice_no?.map((invoice) => {
          return invoice.id ? invoice.id : ""
        })
        info.pay_ref_no = !se.payments
          ? ""
          : se.payments[0]?.payment_mode === "check"
          ? se.payments[0]?.payment_mode + " - " + se.payments[0]?.check_no
          : se.payments[0]?.payment_mode === "bank"
          ? se.payments[0]?.payment_mode + " - " + se.payments[0]?.reference_no
          : se.payments[0]?.payment_mode
        info.pay_id_no = !se.payments
          ? ""
          : se.payments[0]?.se_id
          ? se.payments[0].se_id
          : ""
        return info
      })

      setSuppliesExpenseManager(
        SE.sort(
          (a, b) =>
            new Date(...a.supplies_expense_date?.split("/").reverse()) -
            new Date(...b.supplies_expense_date?.split("/").reverse())
        ).reverse()
      )
      setTotalItems(response.data.size)
    } else {
      setSuppliesExpenseManager([])
    }
    setShowLoader(false)
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    setCurrentTab(tabKey)
    if (tabKey === "complete" || tabKey === "incomplete") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: "",
          order_status: tabKey,
          supplier_id: "",
          vendor_id: "",
          type: "",
          from: dateFilter.date_from || "",
          to: dateFilter.date_to || "",
          page: 1,
        }
      })
    } else {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: tabKey,
          order_status: "",
          supplier_id: "",
          vendor_id: "",
          type: "",
          from: dateFilter.date_from || "",
          to: dateFilter.date_to || "",
          page: 1,
        }
      })
    }
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target
    if (name === "supplier_id") {
      var id = value.split("|")[0]
      var type = value.split("|")[1]
      var by = value.split("|")[2]
      if (by === "supplier") {
        setFilterConfig((prev) => {
          return {
            ...prev,
            ["supplier_id"]: id,
            ["vendor_id"]: "",
            ["type"]: type,
          }
        })
      } else {
        setFilterConfig((prev) => {
          return {
            ...prev,
            ["supplier_id"]: "",
            ["vendor_id"]: id,
            ["type"]: type,
          }
        })
      }
    } else {
      setFilterConfig((prev) => {
        return {
          ...prev,
          [name]: value,
        }
      })
    }
  }

  useEffect(() => {
    searchSuppliesExpense(filterConfig)
  }, [filterConfig, currentPage])

  // function ContractBtn(row) {
  //   return (
  //     <span
  //       className="me-4 align-middle ps-label"
  //       onClick={() => handleViewContract(row.pay_id_no)}
  //     >
  //       {row.pay_ref_no}
  //     </span>
  //   );
  // }

  // function handleViewContract(id, type) {
  //     window.open("/se/purchaseinvoices/print/" + id);
  // }

  function ViewBtn(row) {
    return (
      <>
        {filterConfig.tab === "complete" && (
          <button
            name="action"
            className="btn btn-sm view-btn-table me-1"
            id={row.id}
            onClick={(e) => handleSelectChange(e, row.supplier_id, "sent", row)}
            value="view-supExpense"
          >
            View
          </button>
        )}

        {filterConfig.tab === "incomplete" && (
          <>
            {/* <button
              name="action"
              className="btn btn-sm view-btn-table me-1"
              id={row.id}
              onClick={(e) =>
                handleSelectChange(e, row.supplier_id, "sent", row)
              }
              value="view-supExpense"
            >
              View
            </button>
            <button
              name="action"
              className="btn btn-sm view-btn-table me-1"
              id={row.id}
              onClick={(e) =>
                handleSelectChange(e, row.supplier_id, "sent", row)
              }
              value="close-supExpense"
            >
              Close
            </button> */}
            <button
              name="action"
              className="btn btn-sm view-btn-table"
              id={row.id}
              onClick={(e) =>
                handleSelectChange(e, row.supplier_id, "sent", row)
              }
              value="receive-supExpense"
            >
              Receive
            </button>
          </>
        )}
      </>
    )
  }

  function InvoiceBtn(row) {
    if (row.invoice_no && row.invoice_no.length > 0) {
      return (
        <>
          {row.invoice_no.map((number, index) => (
            <span
              key={index}
              className="invoice-button"
              onClick={() => handleViewInvoice(number)}
            >
              INV-{number}
            </span>
          ))}
        </>
      )
    } else {
      // If row.invoice_no is empty, don't render anything
      return null
    }
  }

  function handleViewInvoice(id) {
    window.open("/se/purchaseinvoices/print/" + id)
  }

  function EditBtn(row, type) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="edit-supExpense"
      >
        Edit
      </button>
    )
  }

  function ReviewBtn(row, type) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="review-supExpense"
      >
        Review
      </button>
    )
  }

  function ReceivePOBtn(row, type) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="receive-supExpense"
      >
        Receive
      </button>
    )
  }

  function ReturnBtn(row, type) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
        value="return-supExpense"
      >
        Back-Pnding
      </button>
    )
  }

  function ContractBtn(row) {
    return (
      <ButtonGroup vertical>
        <>
          {row.payments?.map((row) => {
            return (
              <button
                type="button"
                className="button-secondary table-button me-3"
                onClick={() => handleViewContract(row.id, row.payment_mode)}
              >
                {row.doc_no}
              </button>
            )
          })}
        </>
      </ButtonGroup>
    )
  }

  function handleViewContract(id, payment_mode) {
    // window.open("/purchaseinvoices/print/" + id);
    window.open("/se/paysuppliers/view/" + id + "/" + payment_mode, "_blank")
  }

  function ActionBtn(row, type) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row.supplier_id, type, row)}
      >
        <option value="" selected hidden>
          Select
        </option>
        {type === "deleted" ? (
          <>
            <option value="view-supExpense" className="color-options">
              View
            </option>
          </>
        ) : (
          <>
            {type.startsWith("approved") ? (
              <>
                <option value="print-supExpense" className="color-options">
                  {type.includes("printed") ? "Reprint" : "Print"}
                </option>
                <option value="email-supExpense" className="color-options">
                  Email to Supplier
                </option>
              </>
            ) : (
              <>
                {type === "sent" ? (
                  <>
                    <option value="print-supExpense" className="color-options">
                      Print
                    </option>
                    <option
                      value="receive-supExpense"
                      className="color-options"
                    >
                      Receive
                    </option>
                    {/* <option value="email-supExpense" className="color-yellow">
                      Email to Supplier
                    </option> */}
                  </>
                ) : (
                  <>
                    {type === "disapproved" ? (
                      <>
                        <option
                          value="return-supExpense"
                          className="color-yellow"
                        >
                          Return to Pending
                        </option>
                      </>
                    ) : (
                      <>
                        {type === "for_approval" ? (
                          <>
                            <option
                              value="review-supExpense"
                              className="color-options"
                            >
                              Review for Approval
                            </option>
                          </>
                        ) : (
                          <>
                            {/* {type === "incomplete" ? (
                              <>
                                <option
                                  value="review-po"
                                  className="color-options"
                                >
                                  View
                                </option>
                                <option
                                  value="close-po"
                                  className="color-options"
                                >
                                  Close
                                </option>
                              </>
                            ) : (
                            <> */}
                            {isAdmin && (
                              // <option
                              //   value="edit-supExpense"
                              //   className="color-options"
                              // >
                              //   Edit
                              // </option>
                              <>
                                <option
                                  value="view-po"
                                  className="color-options"
                                >
                                  View
                                </option>
                                <option
                                  value="close-po"
                                  className="color-options"
                                >
                                  Close
                                </option>
                              </>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {userType === "admin" &&
              type !== "incomplete" &&
              type !== "sent" &&
              type !== "approved" && (
                <option value="delete-supExpense" className="color-red">
                  Delete
                </option>
              )}
          </>
        )}
      </Form.Select>
    )
  }

  function AddPaymentBtn(row, type) {
    if (row.can_be_paid === "0") {
      return (
        <button
          name="action"
          className="btn btn-sm view-btn-table"
          id={row.id}
          onClick={(e) => handleSelectChange(e, row.supplier_id, type, row)}
          value="payment-po"
        >
          Add PMT
        </button>
      )
    }
  }

  function handleOnCheck(row) {
    setCheckedItems(row.selectedRows)
  }

  async function handleApproveSE() {
    const response = await changeMultipleStatusSE(checkedItems, "sent")

    if (response.data) {
      toast.success("Supplies expense/s approved successfully", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      // TokenExpiry(response);
      toast.error("Error approving Supplies expense/s", {
        style: toastStyle(),
      })
    }
  }

  async function handleDisapproveSE() {
    const response = await changeMultipleStatusSE(checkedItems, "disapproved")

    if (response.data) {
      toast.success("Supplies expense/s approved successfully", {
        style: toastStyle(),
      })
      setTimeout(() => refreshPage(), 1000)
    } else {
      // TokenExpiry(response);
      toast.error("Error approving Supplies expense/s", {
        style: toastStyle(),
      })
    }
  }

  useEffect(() => {
    fetchSuppliers()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SUPPLIES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              EXPENSE PURCHASE ORDER
            </h1>
          </Col>
          <Col
            xs={12}
            lg={3}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="anything"
              placeholder="Search..."
              className="search-bar"
              onChange={(e) =>
                setFilterConfig((prev) => ({ ...prev, term: e.target.value }))
              }
            />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <button
                className="add-btn"
                onClick={() => navigate("/suppliesexpenses/add")}
              >
                Add
              </button>
            </div>
          </Col>
        </Row>

        {/* tabs */}
        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          id="SE-tabs"
          onSelect={handleTabSelect}
          // className="TabStyle1"
        >
          <Tab eventKey="pending" title="pending">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={suppliers}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="from"
                  placeholderText={"Select Date From"}
                  selected={filterConfig.from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="to"
                  placeholderText={"Select Date To"}
                  selected={filterConfig.to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  // minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                " ",
                "SE NO.",
                "DATE",
                "SUPPLIER",
                "BRANCH",
                "TOTAL",
                "PREPARED BY",
                // "APPROVED BY",
                "ACTIONS",
              ]}
              headerSelector={[
                "",
                "id",
                "supplies_expense_date",
                "supplier_trade_name",
                "branch_name",
                "grand_total",
                "prepared_by_name",
                // "approved_by_name",
              ]}
              tableData={suppliesExpenseManager}
              PendingBtn={(row) => EditBtn(row, "pending")}
              ActionBtn={(row) => ActionBtn(row, "pending")}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="for_approval" title="for approval">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={suppliers}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="from"
                  placeholderText={"Select Date From"}
                  selected={filterConfig.from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="to"
                  placeholderText={"Select Date To"}
                  selected={filterConfig.to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  // minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <AdjustmentTableWithDynamicPagination
              tableHeaders={[
                "-",
                "SE NO.",
                "DATE",
                "SUPPLIER",
                "TOTAL",
                "PREPARED BY",
                // "APPROVED BY",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "id",
                "supplies_expense_date",
                "supplier_trade_name",
                "grand_total",
                "prepared_by_name",
                // "approved_by_name",
              ]}
              tableData={suppliesExpenseManager}
              ViewBtn={(row) => ReviewBtn(row, "for approval")}
              ActionBtn={(row) => ActionBtn(row, "for_approval")}
              handleOnCheck={(row) => handleOnCheck(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="sent" title="sent">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={suppliers}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="from"
                  placeholderText={"Select Date From"}
                  selected={filterConfig.from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="to"
                  placeholderText={"Select Date To"}
                  selected={filterConfig.to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  // minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "+",
                " ",
                "SE NO.",
                "DATE",
                "SUPPLIER",
                "TYPE",
                "TOTAL",
                // "BALANCE",
                "PREP BY",
                "APV BY",
                "ACTIONS",
              ]}
              headerSelector={[
                "+",
                "",
                "id",
                "supplies_expense_date",
                "supplier_trade_name",
                "type",
                "grand_total",
                // "balance",
                "prepared_by_name",
                "approved_by_name",
              ]}
              tableData={suppliesExpenseManager}
              PendingBtn={(row) => ReceivePOBtn(row, "sent")}
              ActionBtn={(row) => ActionBtn(row, "sent")}
              PaymentBtn={(row) => AddPaymentBtn(row, "sent")}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="incomplete" title="incomplete">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={suppliers}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="from"
                  placeholderText={"Select Date From"}
                  selected={filterConfig.from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="to"
                  placeholderText={"Select Date To"}
                  selected={filterConfig.to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  // minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                " ",
                "SE NO.",
                "INV NO.",
                "DATE",
                "SUPPLIER",
                "TYPE",
                "TOTAL",
                // "BALANCE",
                "PREP BY",
                "APV BY",
                "ACTIONS",
              ]}
              headerSelector={[
                "",
                "id",
                "invoice_no",
                "supplies_expense_date",
                "supplier_trade_name",
                "type",
                "grand_total",
                // "balance",
                "prepared_by_name",
                "approved_by_name",
              ]}
              tableData={suppliesExpenseManager}
              PendingBtn={(row) => ViewBtn(row)}
              showLoader={showLoader}
              ActionBtn={(row) => ActionBtn(row, "incomplete")}
              InvoiceBtn={(row) => InvoiceBtn(row)}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="complete" title="completed">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={suppliers}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="from"
                  placeholderText={"Select Date From"}
                  selected={filterConfig.from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="to"
                  placeholderText={"Select Date To"}
                  selected={filterConfig.to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  // minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "SE NO.",
                "INV NO.",
                "DATE",
                "SUPPLIER",
                "TYPE",
                "TOTAL",
                // "BALANCE",
                "PMT REF NO",
                "PREP BY",
                "APV BY",
              ]}
              headerSelector={[
                "-",
                "id",
                "invoice",
                "supplies_expense_date",
                "supplier_trade_name",
                "type",
                "grand_total",
                // "balance",
                "pay_ref_no",
                "prepared_by_name",
                "approved_by_name",
              ]}
              tableData={suppliesExpenseManager}
              ViewBtn={(row) => ViewBtn(row)}
              InvoiceBtn={(row) => InvoiceBtn(row)}
              newTabBtn={(row) => ContractBtn(row, row.status)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="disapproved" title="disapproved">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
              Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter"
                  classNamePrefix="react-select"
                  placeholder="Select Supplier"
                  styles={selectDropdownStyle}
                  value={selectedSupplier}
                  options={suppliers}
                  onChange={handleSupplierChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="from"
                  placeholderText={"Select Date From"}
                  selected={filterConfig.from}
                  onChange={(date) => {
                    setDateFrom(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, from: date }
                    })
                  }}
                  // maxDate={dateToday}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  name="to"
                  placeholderText={"Select Date To"}
                  selected={filterConfig.to}
                  onChange={(date) => {
                    setDateTo(moment(date).format("YYYY-MM-DD"))
                    setFilterConfig((prev) => {
                      return { ...prev, to: date }
                    })
                  }}
                  // maxDate={dateToday}
                  // minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                " ",
                "SE NO.",
                "DATE",
                "SUPPLIER",
                "TYPE",
                "TOTAL",
                "PREP BY",
                "APV BY",
                "ACTIONS",
              ]}
              headerSelector={[
                "",
                "id",
                "supplies_expense_date",
                "supplier_trade_name",
                "type",
                "grand_total",
                "prepared_by_name",
                "approved_by_name",
              ]}
              tableData={suppliesExpenseManager}
              PendingBtn={(row) => ReturnBtn(row, "disapproved")}
              ActionBtn={(row) => ActionBtn(row, "disapproved")}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
        {filterConfig.tab === "for_approval" && getType() === "admin" ? (
          <>
            <div className="d-flex justify-content-end pt-3 mb-3 mr-3">
              <button
                type="button"
                className="button-primary mr-3 "
                onClick={() => handleShowApproveModal()}
              >
                Approve
              </button>
              <button
                type="button"
                className="button-secondary"
                onClick={() => handleShowDisapproveModal()}
              >
                Disapprove
              </button>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>

      {/* modals */}
      <DeleteModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        text="supplies expense"
        onDelete={handleDeleteSuppliesExpense}
        isClicked={isClicked}
      />
      <SEModal
        show={showReturnModal}
        hide={handleCloseReturnModal}
        type="return"
        handler={handleReturnSE}
      />
      <POModal
        show={showClosePOModal}
        hide={handleCloseClosePOModal}
        type="close"
        handler={handleClosePO}
        isClicked={isClicked}
      />
      <PoPaymentModal
        id={supExpenseID.id}
        show={showAddPaymentModal}
        onHide={handleCloseAddPaymentModal}
        balance={bal}
        payee={supExpenseID.name}
      />
      <SEModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        type="approve"
        handler={handleApproveSE}
      />
      <SEModal
        show={showDisapproveModal}
        hide={handleCloseDisapproveModal}
        type="disapprove"
        handler={handleDisapproveSE}
      />
      <Footer />
    </div>
  )
}
